/* global axios */
import ApiClient from './ApiClient';

class TasksAPI extends ApiClient {
  constructor() {
    super('tasks', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  getAvailableBlockers(excludeId, query = '') {
    return this.get({
      status: ['open', 'in_progress', 'in_review'],
      exclude_id: excludeId,
      per_page: 100,
      ...(query ? { q: query } : {}),
    });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(taskData) {
    return axios.post(this.url, { task: taskData });
  }

  update(id, taskData) {
    return axios.patch(`${this.url}/${id}`, { task: taskData });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  meta() {
    return axios.get(`${this.url}/meta`);
  }

  board(params = {}) {
    return axios.get(`${this.url}/board`, { params });
  }

  assign(id, assigneeId) {
    return axios.post(`${this.url}/${id}/assign`, { assignee_id: assigneeId });
  }

  addBlocker(id, blockerDisplayId) {
    return axios.post(`${this.url}/${id}/blockers/${blockerDisplayId}`);
  }

  removeBlocker(id, blockerDisplayId) {
    return axios.delete(`${this.url}/${id}/blockers/${blockerDisplayId}`);
  }

  uploadAttachment(id, file) {
    const formData = new FormData();
    formData.append('attachment', file);
    return axios.post(`${this.url}/${id}/attachments`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  removeAttachment(id, attachmentId) {
    return axios.delete(`${this.url}/${id}/attachments/${attachmentId}`);
  }

  getComments(id) {
    return axios.get(`${this.url}/${id}/comments`);
  }

  createComment(id, { content, metadata = {} } = {}) {
    return axios.post(`${this.url}/${id}/comments`, {
      task_comment: { content, metadata },
    });
  }
}

export default new TasksAPI();
